<!-- =========================================================================================
    File Name: GridResponsiveGrids.vue
    Description: Create responsive grids using tailwind css
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card code-toggler title="Responsive Grids">

    <p>Use the responsive variants of the width utilities to build responsive grid layouts</p>

    <div class="mt-5">
      <div class="flex flex-wrap mb-base">
        <vs-button @click="colClass = 'w-full'" class="mr-4 mb-4" type="border">All (w-full)</vs-button>
        <vs-button @click="colClass = 'w-1/2'" class="mr-4 mb-4" type="border">sm:w-1/2</vs-button>
        <vs-button @click="colClass = 'w-1/3'" class="mr-4 mb-4" type="border">md:w-1/3</vs-button>
        <vs-button @click="colClass = 'w-1/4'" class="mr-4 mb-4" type="border">lg:w-1/4</vs-button>
        <vs-button @click="colClass = 'w-1/6'" class="mr-4 mb-4" type="border">xl:w-1/6</vs-button>
      </div>
      <div class="flex flex-wrap">
        <div :class="colClass" class="mb-4 h-12 bg-grid-color"></div>
        <div :class="colClass" class="mb-4 h-12 bg-grid-color-secondary"></div>
        <div :class="colClass" class="mb-4 h-12 bg-grid-color"></div>
        <div :class="colClass" class="mb-4 h-12 bg-grid-color-secondary"></div>
        <div :class="colClass" class="mb-4 h-12 bg-grid-color"></div>
        <div :class="colClass" class="mb-4 h-12 bg-grid-color-secondary"></div>
      </div>
    </div>

    <template slot="codeContainer">
      &lt;div class=&quot;flex flex-wrap&quot;&gt;
      &lt;div class=&quot;w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/6 mb-4 bg-grid-color&quot;&gt;&lt;/div&gt;
      &lt;div class=&quot;w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/6 mb-4 bg-grid-color-secondary&quot;&gt;&lt;/div&gt;
      &lt;div class=&quot;w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/6 mb-4 bg-grid-color&quot;&gt;&lt;/div&gt;
      &lt;div class=&quot;w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/6 mb-4 bg-grid-color-secondary&quot;&gt;&lt;/div&gt;
      &lt;div class=&quot;w-full sm:w-1/2 md:w-1/3 lg:w-1/2 xl:w-1/6 mb-4 bg-grid-color&quot;&gt;&lt;/div&gt;
      &lt;div class=&quot;w-full sm:w-1/2 md:w-1/3 lg:w-1/2 xl:w-1/6 mb-4 bg-grid-color-secondary&quot;&gt;&lt;/div&gt;
      &lt;/div&gt;
    </template>
  </vx-card>
</template>

<script>
  export default {
    data ()
    {
      return {
        colClass: 'w-full'
      }
    }
  }
</script>
